import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService, BaseComponent, BaseComponentMode, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { SalesManagerShopItemsService } from "./salesmanagershopitems.service";
import { TranslateService } from "@ngx-translate/core";
import { SalesManagerShopItem } from "../../api-models/SalesManagerShopItem";
import { SalesManagerShopItemCategory, SalesManagerShopItemCategoryArray } from "@impacgroup/ayyildiz-checklist-platform-api-dtos";
import { getSalesManagerItemCategoryI18N } from "../../utils/itemcategories";

@Component({
    selector: "app-salesmanagershopitemdetail",
    templateUrl: "./salesmanagershopitemdetail.component.html",
    styleUrls: ["salesmanagershopitemdetail.component.scss"],
    standalone: false
})
export class SalesManagerShopItemDetailComponent extends BaseComponent implements OnInit {
    private salesManagerShopItemId: string = null;
    public salesManagerShopItem: SalesManagerShopItem = null;

    public categories: { label: string; value: SalesManagerShopItemCategory }[] = null;

    constructor(
        private route: ActivatedRoute,
        private salesManagerShopItemsService: SalesManagerShopItemsService,
        private router: Router,
        private alertService: AlertService,
        private translateService: TranslateService,
        private _location: Location
    ) {
        super();

        this.subscriptions.push(
            this.route.params.subscribe((params) => {
                this.salesManagerShopItemId = params.id;
                if (this.salesManagerShopItemId) {
                    this.initEditMode();
                } else {
                    this.initAddMode();
                }
            })
        );

        this.categories = SalesManagerShopItemCategoryArray.map((categoryType: SalesManagerShopItemCategory) => {
            return {
                label: this.translateService.instant(getSalesManagerItemCategoryI18N(categoryType)),
                value: categoryType
            };
        });
    }

    ngOnInit(): void {}

    initAddMode() {
        this.MODE = BaseComponentMode.ADD;
        this.salesManagerShopItem = new SalesManagerShopItem();
    }

    initEditMode() {
        this.MODE = BaseComponentMode.EDIT;

        this.subscriptions.push(
            this.salesManagerShopItemsService.salesManagerShopItemDetail(this.salesManagerShopItemId).subscribe(
                (result) => {
                    this.salesManagerShopItem = result;
                },
                (err) => {
                    this.router.navigate(["../"], { relativeTo: this.route });
                }
            )
        );
    }

    save() {
        if (!this.salesManagerShopItem.category) {
            return;
        }

        if (this.MODE === BaseComponentMode.ADD) {
            this.subscriptions.push(
                this.salesManagerShopItemsService.addSalesManagerShopItem(this.salesManagerShopItem).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("salesmanagershopitems.detail.add.success"));
                    this.router.navigate(["../"], { relativeTo: this.route });
                })
            );
        }

        if (this.MODE === BaseComponentMode.EDIT) {
            this.subscriptions.push(
                this.salesManagerShopItemsService.updateSalesManagerShopItem(this.salesManagerShopItem).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("salesmanagershopitems.detail.edit.success"));
                    this.router.navigate(["../"], { relativeTo: this.route });
                })
            );
        }
    }

    back() {
        this._location.back();
    }
}
